module.exports = __webpack_public_path__ + "static/media/ines-forum-3.a615533a.jpg";